module.exports = __webpack_public_path__ + "img/scan.b77afb27.svg";